<template>
<div class="analytics analytics-outlets">
  <row>
    <el-tabs v-model="tab" type="border-card" @tab-click="tabClick">
      <!-- tab transactions start -->
      <el-tab-pane :label="$t('Views.Analytics.Store.trx')" name="first">
        <row>
          <div class="sl-col-4">
            <div class="sl-body">
              <p class="sl-name">{{$t('Chart.outletPerChannel')}}</p>
              <p class="text-center">
                <el-radio-group v-model="first.channelRadio">
                  <el-radio-button label="op0" @click.native="resetPerChannelOption(`today`,'Today')" :option="first.channelOption.today">{{$t('Date.today')}}</el-radio-button>
                  <el-radio-button label="op1" @click.native="resetPerChannelOption(`week`,'Recent 7 days')" :option="first.channelOption.week">{{$tc('Date.dateRange',0)}}</el-radio-button>
                  <el-radio-button label="op2" @click.native="resetPerChannelOption(`month`,'Recent 30 days')" :option="first.channelOption.month">{{$tc('Date.dateRange',1)}}</el-radio-button>
                  <el-radio-button label="op3" @click.native="resetPerChannelOption(`year`,'Recent 12 months')" :option="first.channelOption.year">{{$tc('Date.dateRange',2)}}</el-radio-button>
                </el-radio-group>
              </p>
              <chart :options="first.channelOption.default" ref="perChannel" auto-resize theme="default"></chart>
            </div>
          </div>
        </row>
      </el-tab-pane>
      <!-- tab transactions end -->
      <!-- tab percentage start -->
      <el-tab-pane :label="$t('Views.Analytics.Store.percent')" name="second">
        <!-- transactions by outlet start  -->
        <div class="sl-col-4">
          <div class="sl-body">
            <p class="sl-name">{{$t('Chart.transactionsByOutlet')}}</p>
            <chart :options="second.transactionsOption" ref="percentageTransactions" auto-resize theme="default" class="sl-chart-bar"></chart>
          </div>
        </div>
        <!-- transactions by outlet end  -->
        <!-- refund by outlet start  -->
        <div class="sl-col-4">
          <div class="sl-body">
            <p class="sl-name">{{$t('Chart.RefundByOutlet')}}</p>
            <chart :options="second.refundOption" ref="percentageRefund" auto-resize theme="default" class="sl-chart-bar"></chart>
          </div>
        </div>
        <!-- refund by outlet end  -->
        <!-- Reversal by outlet start  -->
        <!-- <div class="sl-col-4">
          <div class="sl-body">
            <p class="sl-name">{{$t('Chart.ReversalByOutlet')}}</p>
            <chart :options="second.reversalOption" ref="percentageReversal" auto-resize theme="default" class="sl-chart-bar"></chart>
          </div>
        </div> -->
        <!-- Reversal by outlet end  -->
      </el-tab-pane>
      <!-- tab percentage end -->
    </el-tabs>
  </row>
</div>
</template>

<script>
import api from '../../api'
import * as config from '../../util/echart-config'
export default {
  name: 'analytics-outlets',
  data() {
    return {
      tab: 'first',
      first: {
        channelOption: {
          default: null,
          today: {},
          week: {},
          month: {},
          year: {}
        },
        channelRadio: 'op0'
      },
      second: {
        transactionsOption: null,
        refundOption: null
        // reversalOption: null
      }
    }
  },
  methods: {
    tabClick() {
      const vm = this
      if (this.tab === 'first') {
        this.first.channelRadio = 'op0'
        api.FetchAnalyticsOutletsTabAChart().then(res => {
          const result = res.data.data
          vm.first.channelOption.default = config.getMultipleAreaOption(result.hour, config)
          vm.first.channelOption.today = createOption(result.hour)
          vm.first.channelOption.week = createOption(result.week)
          vm.first.channelOption.month = createOption(result.month)
          vm.first.channelOption.year = createOption(result.year)
          vm.$nextTick(function () {
            vm.$refs.perChannel.resize()
          })
        })
      } else if (this.tab === 'second') {
        api.FetchAnalyticsOutletsTabBChart().then(res => {
          const result = res.data.data
          vm.second.transactionsOption = config.getSinglePieOption(result.transaction, config)
          // vm.second.reversalOption = config.getSinglePieOption(result.reversal, config)
          vm.second.refundOption = config.getSinglePieOption(result.refund, config)
          vm.$nextTick(function () {
            vm.$refs.percentageTransactions.resize()
            vm.$refs.percentageRefund.resize()
            // vm.$refs.percentageReversal.resize()
          })
        })
      }
    },
    resetPerChannelOption(params, name) {
      this.$refs.perChannel.mergeOptions({
        xAxis: [
          {
            data: this.first.channelOption[params].xAxis
          }
        ],
        series: this.first.channelOption[params].yAxis
      })
    }
  },
  created() {
    const vm = this
    api.FetchAnalyticsOutletsTabAChart().then(res => {
      const result = res.data.data
      vm.first.channelOption.default = config.getMultipleAreaOption(result.hour, config)
      vm.first.channelOption.today = createOption(result.hour)
      vm.first.channelOption.week = createOption(result.week)
      vm.first.channelOption.month = createOption(result.month)
      vm.first.channelOption.year = createOption(result.year)
      vm.$nextTick(function () {
        vm.$refs.perChannel.resize()
      })
    })
  }
}

function createOption(op) {
  op.yAxis = op.yAxis.map(item => ({
    name: item.name,
    data: item.value,
    type: 'line',
    areaStyle: {
      normal: {}
    }
  }))
  return op
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// outlets.vue?4a875780